import { Tooltip } from '@crazyegginc/hatch';

import { GoalTriggerList } from '/src/features/goals/components/GoalTriggerList';

export function GoalTriggersTooltip({ triggers, placement = 'right', className, filterDeleted = true, children }) {
  const hasTriggers = Array.isArray(triggers) && triggers.length > 0;

  if (!hasTriggers) {
    return null;
  }

  return (
    <Tooltip
      interactive={true}
      placement={placement}
      style={{ padding: '0px' }}
      tooltipContent={<GoalTriggerList triggers={triggers} filterDeleted={filterDeleted} />}
    >
      <button
        type="button"
        className={className}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
      >
        {children}
      </button>
    </Tooltip>
  );
}
